import type { EntitySearchResult } from "@/components/ResearchCms/EntitySearchPicker/EntitySearchPicker";

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function buildFirmSpan(entity: EntitySearchResult): string {
  return `<span class="legalease-display-reference" data-type="account" data-id="${escapeHtml(entity.id)}" data-office-id="${escapeHtml(entity.officeId ?? "")}" data-disabled-flag="FALSE">${escapeHtml(entity.name)}</span>`;
}

export function buildLawyerSpan(entity: EntitySearchResult): string {
  return `<span class="legalease-display-reference" data-type="contact" data-id="${escapeHtml(entity.id)}" data-office-id="${escapeHtml(entity.officeId ?? "")}" data-contact-id="${escapeHtml(entity.wpTermId ?? "")}" data-parent-type="account" data-parent-id="${escapeHtml(entity.parentId ?? "")}" data-disabled-flag="${entity.wpTermId ? "FALSE" : "TRUE"}">${escapeHtml(entity.name)}</span>`;
}
